import { memo } from "react";

// styled
import styled from "styled-components";

// mui
import { Stack, Divider } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

// icon renderer
import { renderIcon } from "utils/helpers/typeKitchen";

// add child specification button
import AddSpecificationButton from "./AddSpecificationButton";

const Specification = ({
  data: {
    name,
    article,
    restaurant,
    items = [],
    color: { hue, saturation, lightness },
  },
  remove = () => { },
}) => (
  <Item $h={hue} $s={saturation} $l={lightness}>
    <TitleRow>
      <span>
        <img src={renderIcon(restaurant)} />
        {name}
      </span>
      <CloseButton onClick={remove.bind(null, article)}>
        <CloseIcon style={{ fontSize: 36 }} />
      </CloseButton>
    </TitleRow>
    <Stack divider={<Divider />}>
      {items.map((item, index) => (
        <Ingredient key={`${item.uuid}-${index}`}>
          {item.name} ({item.quantity} {item.unit}.)
          {(item.unit === "порц") && (
            <AddSpecificationButton 
              article={item.artikul}
              parent={article} 
            />
          )}
        </Ingredient>
      ))}
    </Stack>
  </Item>
);

const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(p) => p.theme.accentColor};
    border-radius: 50%;
    background-color: transparent;

    &:hover {
        cursor: pointer;
        background-color: ${(p) => p.theme.backgroundHover};
    }
`;

const Item = styled.div`
    height: min-content;
    font-size: 18px;
    background-color: ${(p) => `hsl(${p.$h}, ${p.$s}%, ${p.$l}%)`};

    border: 1px solid #DEDEDE;
    border-radius: 8px;

    & span {
      padding-left: 8px;
    }

    padding: 8px 0 8px 0;
`;

const Ingredient = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const TitleRow = styled.div`
    font-weight: bold; 
    font-size: 20px;

    display: flex;
    justify-content: space-between;

    & span {
      display: flex;
      gap: 8px;

      & > img {
        max-width: 28px;
      }

      align-items: center;
    }
`;

export default memo(Specification);
